import { z } from 'zod';

export const slugBaseSchema = z
    .string({ invalid_type_error: 'основа slug должна быть строкой' })
    .trim()
    .min(1, 'основа slug не может быть пустой')
    .max(120, 'основа slug не должна превышать 120 символов')
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'основа slug может содержать латиницу, цифры и дефисы');
